<template>
  <v-select
    v-model="selectedItem"
    :items="items"
    label="CEP"
    required
    :disabled="disabled"
    :rules="validate.multipleRules"
    :mask="mask.cep"
    item-text="zipCode"
    chips
    :menu-props="{contentClass: dataCy + ' small-chips'}"
    ref="select"
    :data-cy="dataCy"
    @input="inputItem"
    @blur="blurEvent"
  >
    <template slot="selection" slot-scope="data">
      <v-chip
      close
      @input="data.parent.selectItem(data.item)"
      :selected="data.selected"
      >
        {{data.item.zipCode}}
      </v-chip>
    </template>
    <template slot="item" slot-scope="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-tile-content v-text="data.item.zipCode"></v-list-tile-content>
      </template>
      <template>
        <v-list-tile-content>
          <v-list-tile-title>{{data.item.zipCode}} - {{data.item.typology}} {{data.item.address}}
            <v-chip
              v-if="data.item.isMain"
              label
              color="darkGray"
              text-color="white"
              small
              class="chip"
            >principal</v-chip>
          </v-list-tile-title>
        </v-list-tile-content>
      </template>
    </template>
  </v-select>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        default: [],
        required: true
      },
      dataCy: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      empty: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        selectedItem: [],
        listCeps: []
      }
    },
    methods: {
      inputItem (item) {
        if (typeof (item[0]) === 'string') {
          let zipCode = {
            zipCode: item[0],
            typology: '',
            address: ''
          }
          this.resetField()
          this.selectedItem.push(zipCode)
          this.$emit('change', this.selectedItem)
        }
        if (typeof (item[0]) === 'object' && item.length > 0) {
          this.replaceItem(item)
          this.$emit('change', this.selectedItem)
        }
      },
      replaceItem (item) {
        this.$refs.select.blur()
        if (item.length > 1) {
          this.selectedItem = item.slice(-1)
        } else {
          this.selectedItem = item
        }
      },
      blurEvent () {
        this.$emit('blur')
      },
      resetField () {
        this.selectedItem = []
      },
      emitEmptyStatus () {
        this.$emit('empty')
      }
    },
    watch: {
      empty (isEmpty) {
        isEmpty && this.resetField()
      },
      selectedItem (cep) {
        cep.length === 0 && this.emitEmptyStatus()
      }
    }
  }
</script>
